import React from "react";
import { ServiceCenterForm } from "./Forms/ServiceCenterForm";
import { useCreateServiceCenterMutation } from "../../services/basicData/basicData";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Container, Form, Spinner } from "reactstrap";
import { Stack } from "react-bootstrap";

const getSystemFromPath = (pathname) =>
  pathname?.includes("madina") ? "madina" : "makkah";

export const CreateServiceCenter = () => {
  const location = useLocation();
  const system = getSystemFromPath(location.pathname);
  const {
    handleSubmit,
    control,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      name_ar: "",
      name_en: "",
      code: "",
      address: "",
      phone: "",
      manager_id: null,
      nationality_id: null,
    },
  });

  const { mutate: createServiceCenter, isPending } = useCreateServiceCenterMutation(setError, { system });
  const { t } = useTranslation();

  const onSubmit = (data) => {
    const payload = {
      code: data.code,
      name_ar: data.name_ar,
      name_en: data.name_en,
      address: data.address,
      phone: data.phone,
      manager_id: data.manager_id ?? null,
      ...(system === "madina" && {
        nationality_id: data.nationality_id ?? null,
      }),
    };
    createServiceCenter(payload);
  };

  return (
    <Stack gap={2}>
      <PageHeader title={t("CREATE_SERVICE_CENTER")} />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <ServiceCenterForm control={control} errors={errors} system={system} />
          <Button variant="primary" type="submit" disabled={isPending}>
            {isPending ? (
              <>
                <Spinner size="sm" />
                {t("CREATING_SERVICE_CENTER")}
              </>
            ) : (
              t("CREATE_SERVICE_CENTER")
            )}
          </Button>
        </Form>
      </Container>
    </Stack>
  );
};

